// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2198W","header":"ReportDetails_header__pe2U-","title":"ReportDetails_title__3rW1K","left":"ReportDetails_left__hL4iq"};